import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import RightDrawerDesktop from "../../../../components/WMS/Desktop/RightDrawerDesktop";
import {getWMSContainers} from "../../../../api/wms/wmsContainers/wmsContainers";
import Toggle from "../../../../components/WMS/Mobile/Toggle/Toggle";
import {FormattedMessage} from "react-intl";
import {Card, CardContent, FormControlLabel, Grid, Radio, RadioGroup} from "@mui/material";
import ToggleNavigation from "../../../../components/WMS/Mobile/Toggle/ToggleNavigation";
import CustomButton from "../../../../components/CustomButton";
import {WMSContext} from "../../context/WMSContext";
import {grey300, greyishBlue500} from "../../../../assets/jss/main";
import useIsMobile from "hooks/useIsMobile";
import {WmsContainerType} from "../../../../utils/WMSContainerType";

TrolleyOrZoneDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleZoneOrTrolleySelection: PropTypes.func.isRequired,
};

function TrolleyOrZoneDrawer({open, handleClose, handleZoneOrTrolleySelection}) {
    const isMobile = useIsMobile()
    const {currentInventory, currentMember} = useContext(WMSContext)
    const [trolleyOrZone, setTrolleyOrZone] = useState(0)
    const [choiceValue, setChoiceValue] = useState()
    const [trolleys, setTrolleys] = useState()
    const [zones, setZones] = useState()

    const handleChange = (event) => {
        let isTrolley = false
        if (trolleyOrZone === 1) {
            isTrolley = true
        }
        setChoiceValue({
            isTrolley: isTrolley,
            containerCodebar: event.target.value
        })
    };

    useEffect(() => {
        if (open && currentInventory) {
            const typeParameters = `type[]=${WmsContainerType.TROLLEY}&type[]=${WmsContainerType.CC}`

            getWMSContainers(currentInventory.id, typeParameters).then(containers => {
                setTrolleys(containers.filter((container) => container.type === WmsContainerType.TROLLEY));
                setZones(containers.filter((container) => container.type === WmsContainerType.CC));
            });
        }
    }, [open, currentInventory]);

    return (
        <RightDrawerDesktop
            open={open}
            onClose={handleClose}
            disablePortal
            withoutHeadBorder={isMobile}
            openMaxWidth={isMobile}
            title={
                <span style={{
                    fontSize: "16px",
                    fontWeight: 600
                }}>
                    <FormattedMessage id={"wms.ccReceptionList.drawer.title"}/>
                </span>
            }
            subtitle={
                <span style={{
                    color: greyishBlue500,
                    fontWeight: 400,
                    fontSize: "14px"
                }}>
                        <FormattedMessage id={"wms.ccReceptionList.drawer.subtitle"}/>
                </span>
            }
        >
            <Grid
                container
                sx={{height: "100%",}}
                direction={"column"}
            >
                <Card sx={{maxWidth: "100%"}}>
                    <CardContent>
                        <div style={{
                            margin: "auto",
                            width: "fit-content"
                        }}>
                            <ToggleNavigation
                                value={trolleyOrZone}
                                onChange={(value) => {
                                    setTrolleyOrZone(value)
                                }}
                            >
                                <Toggle
                                    label={<FormattedMessage id={"wms.packing.manualDropZoneChoice.filterTag.zone"}/>}
                                    large={!isMobile}
                                    fullWidth={!isMobile}
                                    noWrapText={!isMobile}
                                />
                                <Toggle
                                    label={<FormattedMessage id={"wms.packing.manualDropZoneChoice.filterTag.trolley"}/>}
                                    large={!isMobile}
                                    fullWidth={!isMobile}
                                    noWrapText={!isMobile}
                                />
                            </ToggleNavigation>
                        </div>
                    </CardContent>
                </Card>
                <RadioGroup
                    onChange={handleChange}
                    value={choiceValue}
                >
                    {zones && 0 === trolleyOrZone && (
                        zones.map((zone) => (
                            <Card>
                                <CardContent style={{padding: 0}}>
                                    <FormControlLabel
                                        value={zone.codebar}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row-reverse",
                                            justifyContent: "space-between",
                                            margin: 0,
                                            padding: "16px",
                                            ':hover': {
                                                backgroundColor: grey300,
                                            },
                                        }}
                                        control={<Radio/>}
                                        label={zone.name}
                                    />
                                </CardContent>
                            </Card>
                        ))
                    )}
                    {trolleys && 1 === trolleyOrZone && (
                        trolleys.map((trolley) => (
                            <Card>
                                <CardContent style={{padding: 0}}>
                                    <FormControlLabel
                                        value={trolley.codebar}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row-reverse",
                                            justifyContent: "space-between",
                                            margin: 0,
                                            padding: "16px",
                                            ':hover': {
                                                backgroundColor: grey300,
                                            },
                                        }}
                                        control={<Radio/>}
                                        label={trolley.name}
                                    />
                                </CardContent>
                            </Card>
                        ))
                    )}
                </RadioGroup>

                <div style={{
                    padding: "16px"
                }}>
                    <CustomButton
                        fullWidth
                        disabled={!choiceValue}
                        onClick={() => handleZoneOrTrolleySelection(choiceValue)}
                    >
                        <FormattedMessage id={"wms.packing.manualDropZoneChoice.buttonLabel"}/>
                    </CustomButton>
                </div>
            </Grid>
        </RightDrawerDesktop>
    );
}

export default TrolleyOrZoneDrawer;
